import { sendAnalyticsEvent } from '~shared/lib/analytics/src/actions';
import { EVENTS } from '~shared/lib/analytics/src/constants';
import { createEvent } from '~shared/lib/analytics/src/helper';
import { connect } from '~shared/store';
import { type ReduxDispatchShared } from '~shared/types';
// eslint-disable-next-line import/no-deprecated
import ContactUsLink from './ContactUsLink';

const mapDispatchToProps = (dispatch: ReduxDispatchShared) => ({
  trackContactLinkClicked: (eventName: string, origin: string) => {
    dispatch(
      sendAnalyticsEvent(
        createEvent(EVENTS.CONTACT_US_CLICKED, {
          context: eventName,
          origin,
          web: true,
        }),
      ),
    );
  },
});

const mapStateToProps = () => ({});

/**
 * @deprecated use ContactUs from @alto/features instead.
 */
// eslint-disable-next-line import/no-deprecated
export default connect(mapStateToProps, mapDispatchToProps)(ContactUsLink);
